<template>
    <v-main v-if="org">
        <v-container>
            <v-card>
                <v-card-title>
                    {{org.info.fullname}}
                </v-card-title>
                <v-container>
                    <v-row>
                        <v-col v-for="t in tiles"   :key="t.to">
                            <v-card :to="t.to" outlined height="70" >
                                <v-card-text>
                                    <div class="text-center">
                                        <v-icon>{{icons[t.icon]}}</v-icon>
                                    </div>
                                    <div class="text-center">{{t.name}}</div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-container>
        <router-view></router-view>
    </v-main>
</template>

<script>
  const PATH = '/organization' //im lazy and hate writing `"organi....
  import {
    mapState
  } from 'vuex'
  export default {
    name: "Index",
    data() {
      return {
        menu: true,
        tiles:[
          {to: PATH+'/staff', icon: 'user', name: 'Staff'},
          {to: PATH+'/info', icon: 'info', name: 'Info'},
          {to: PATH+'/social', icon: 'share', name: 'Social'},
          {to: PATH+'/recievepayments', icon: 'dollar', name: 'Recieve'}
        ]
      }
    },
    async created(){
      let f = await this.$store.dispatch('checkPermissions',{permissions:this.permissions,required:this.$route.meta.permissions})
      if(!f){
        this.$router.push('/')
      }
    },
    computed:{
      ...mapState(['permissions','org','icons'])
    },
    mounted() {
    },
    methods: {}
  }
</script>

<style scoped>

</style>